
import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Avatar, Menu, MenuItem, Typography, ListItem, Button, ListItemText, ListItemIcon, CircularProgress, Box } from "@mui/material"

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import { RootState } from "../../store";

import { logout } from "../../store/slices/AuthSlice";

import { AvatarAppBarStyle, ListItembuttonStyle, ListItemIconStyle, ListSubItemStyle, ListTypographyStyle } from '../../styles/ListItemStyle';

import { DialogPerfil } from "../../dialogs/DialogPerfil";

import { Logout } from "../../connections/auth/AuthConnection";
import { DialogConfiguracion } from "../../dialogs/DialogConfiguracion";

export const ListItemPerfil = () => {

    const dispatch = useDispatch();

    const { nombres, apellidos, administrador, sistemaTurnos } = useSelector( ( state: RootState ) => state.auth );
    const { ubicacion } = useSelector( ( state: RootState ) => state.ubicacion );

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [loading, setLoading] = useState(false);
    
    const [openDialogPerfil, setOpenDialogPerfil] = useState(false);
    const [openDialogConfiguracion, setOpenDialogConfiguracion] = useState(false);

    const open = Boolean(anchorEl);   

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {

        setLoading( true );      

        await Logout().then( resp => {

            const { success } = resp;

            if( success ){

                setTimeout(() => {

                    localStorage.setItem('lastPath', '/' );
                    localStorage.clear();
                    
                    dispatch( logout() );
                    setLoading( false );
                
                }, 700);       

            }
            else {

                setTimeout(() => {
                    
                    setLoading( false );
                
                }, 700);  

            }

        });            

    }

    return (
        
        <>

            <ListItem component="div" style={{ textAlign: 'right' }}> 

                <ListItemText style={ListItemIconStyle}>
                
                    <Button color="inherit" sx={ ListItembuttonStyle } onClick={ handleOpenMenu } >

                        <Avatar 
                            variant="square"
                            alt="Mi Avatar"                             
                            style={AvatarAppBarStyle} 
                            src={ process.env.PUBLIC_URL + "/assets/profile.png" }
                        />

                        <Box sx={{ textAlign: 'center', mx: 3, display: { xs: 'none', 'xl': 'block' } }} >

                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    <strong>{ nombres.toUpperCase() } { apellidos.toUpperCase() }</strong>
                                </Typography>
                            </Box>
                           
                            <Box sx={{ textAlign: 'center' }}>
                                { 
                                    administrador 
                                    ? 
                                        <Typography variant="caption" fontSize={14}>( Administrador )</Typography> 
                                    :
                                        ( ubicacion.numero !== 0 && ubicacion.numero ) && <Typography variant="caption">( { ubicacion.nombre } { ubicacion.numero } )</Typography> 
                                }
                            </Box>

                        </Box>

                        <KeyboardArrowDownIcon />       

                    </Button>

                </ListItemText>

            </ListItem>

            <Menu elevation={ 4 } anchorEl={ anchorEl } anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} keepMounted open={ open } onClose={ handleCloseMenu }>  

                <MenuItem sx={{ ...ListSubItemStyle, py: 2 }} disableGutters onClick={ () => { setOpenDialogPerfil( true ); handleCloseMenu(); } }>

                    <ListItemIcon style={ ListItemIconStyle }>    

                        <PersonOutlineIcon style={{ ...ListItemIconStyle, fontSize: 20 }} />                                     

                    </ListItemIcon>

                    <ListItemText style={ListTypographyStyle}> Mi perfil </ListItemText>   

                </MenuItem>    

                {
                    sistemaTurnos !== 0
                    &&
                        <MenuItem sx={{ ...ListSubItemStyle, py: 2 }} disableGutters onClick={ () => { setOpenDialogConfiguracion( true ); handleCloseMenu(); } }>

                            <ListItemIcon style={ ListItemIconStyle }>    

                                <SettingsOutlinedIcon style={{ ...ListItemIconStyle, fontSize: 20 }} />                                     

                            </ListItemIcon>

                            <ListItemText style={ListTypographyStyle}> Configuración </ListItemText>   

                        </MenuItem>    
                }

                <MenuItem sx={{ ...ListSubItemStyle, py: 2 }} onClick={ handleLogout } disableGutters>

                    <ListItemIcon style={ ListItemIconStyle }>         

                        {
                            loading
                            ?
                                <CircularProgress size={18} sx={{ ml: '12px' }}/>
                            :
                                <ExitToAppOutlinedIcon style={{ ...ListItemIconStyle, fontSize: 20 }} />  
                        }              

                    </ListItemIcon>

                    <ListItemText style={{...ListTypographyStyle, marginLeft: loading ? 5 : 0 }}> Salir </ListItemText>   

                </MenuItem>    

            </Menu>  

            <DialogPerfil
                openDialog={ openDialogPerfil }
                handleCloseDialog={ () => setOpenDialogPerfil( false ) }
            />

            <DialogConfiguracion 
                openDialog={ openDialogConfiguracion }
                handleCloseDialog={ () => setOpenDialogConfiguracion( false ) }            
            />

        </>

    )
}